import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
// style
import "./App.css";

// Import Swiper styles
import "swiper/css";
import "swiper/css/zoom";
import "swiper/css/pagination";
import "swiper/css/navigation";

//  chakra ui
import { Box, ChakraProvider } from "@chakra-ui/react";

// chakra's theme
import theme from "./theme";

// bootstrap style
import "bootstrap/dist/css/bootstrap.min.css";

// import containers
import { Contact, Home, Material, Gallery, Lightbox, Info } from "./containers";

// import components
import { MyNavbar, Footer } from "./components";

const App = () => {
  return (
    <HelmetProvider>
      <ChakraProvider theme={theme}>
        <Box className="App">
          <Router>
            <Box className="cover__bg">
              <main>
                <MyNavbar />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/gallery/:gallery" element={<Gallery />} />
                  <Route path="/lightbox" element={<Lightbox />} />
                  <Route path="/material" element={<Material />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/info" element={<Info />} />
                </Routes>
                <Footer />
              </main>
            </Box>
          </Router>
        </Box>
      </ChakraProvider>
    </HelmetProvider>
  );
};

export default App;
